<template>
    <div class="info">
        <div class="title">{{title||'申请人信息'}}</div>
        <Form :label-width="180" class="mt15" v-if="info.applicantList">
            <FormItem label="投保人名称：" class="w600">
                {{info.applicantName}}
            </FormItem>
            <FormItem label="投保人组织机构代码：" class="w600">
                {{info.applicantList[0].idNumber}}
            </FormItem>
            <FormItem label="电话：" class="w600">
                {{info.insuredList[0].contactPhone}}
            </FormItem>
            <!-- <FormItem label="地区：" v-if="info.provinceName&&info.cityName&&info.areaName">
			{{info.provinceName+info.cityName+info.areaName}}
	    </FormItem> -->
            <FormItem label="被保险人名称：" class="w600">
                {{info.insuredList[0].subjectName}}
            </FormItem>
            <FormItem label="被保人通讯地址：" class="w600">
                {{info.insuredList[0].fullAddress}}
            </FormItem>
            <FormItem label="被保人详细地址：" class="w600">
                {{info.insuredList[0].address}}
            </FormItem>
            <FormItem label="邮编：" class="w600">
                {{info.insuredList[0].zipCode}}
            </FormItem>
            <FormItem label="建筑工程项目名称：" class="w600">
                {{info.extraInfo.projectName}}
            </FormItem>
            <FormItem label="建筑工程项目合同地址：" class="w600">
                {{info.extraInfo.projectAddress}}
            </FormItem>
            <FormItem label="工程造价：" class="w600">
                {{info.extraInfo.projectCost}}
            </FormItem>
            <FormItem label="计费方式：" class="w600">
                {{info.extraInfo.chargeMode}}
            </FormItem>
            <FormItem label="建筑工程项目合同期限：" class="w600" v-if="info.businessLicenseUrl">
                {{info.extraInfo.projectDateStart}} - {{info.extraInfo.projectDateEnd}}
            </FormItem>
            <FormItem label="营业执照：" class="w600">
                <div v-for="(item,index) in info.extraInfo.uploadListLicenseArr" :key="index">
                    <div  class="upItem" >
                        <a :href="item.url">{{ item.name }}</a>
                    </div>
                </div>
            </FormItem>
            <FormItem label="工程合同：" class="w600">
                <div v-for="(item,index) in info.extraInfo.uploadList" :key="index">
                    <div  class="upItem" >
                        <a :href="item.url">{{ item.name }}</a>
                    </div>
                </div>
            </FormItem>
            <FormItem label="保单发票邮寄地址：" prop="postAddress" class="w600">
                {{info.extraInfo.postAddress}}
            </FormItem>
            <FormItem label="邮寄联系人：" prop="postContactName" class="w600">
                {{info.extraInfo.postContactName}}
            </FormItem>
            <FormItem label="邮寄联系人电话：" prop="postContactPhone" class="w600">
                {{info.extraInfo.postContactPhone}}
            </FormItem>
        </Form>
    </div>
</template>
<script>
    import ImageShow from '../../common/Image'
    import UploadFileImg from '@/components/common/UploadFileImg'
    export default {
        components: { ImageShow, UploadFileImg },
        props: {
            info: Object,
            title: String
        },
        data () {
            return {

            }
        },
        created () {

        },
        methods: {
            // 上传回调方法
            uploadSuccess (val, key) {
                this.info.businessLicenseUrl = val.url
            },
            delImg (index) {
                this.info.businessLicenseUrl = ''
            }
        }
    }
</script>
<style scoped>
    .upItem{
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/common/ApplicantInfo.vue